export enum EReasonType {
  Atendimento = 'atendimento',
  Cancelamento = 'cancelamento',
}
